export function searchStarted(queryId) {
  return {
    searches: {
      queries: {
        [queryId]: {
          type: 'STARTED',
        },
      },
    },
  }
}

export function searchSuccess({
  queryId,
  nodes,
  currentCursor,
  startCursor,
  endCursor,
  hasNextPage,
  hasPreviousPage,
  totalCount,
  totalPageCount,
}) {
  return {
    searches: {
      queries: {
        [queryId]: {
          type: 'SUCCESS',
          result: {
            nodes,
            pageInfo: { startCursor, endCursor, hasNextPage, hasPreviousPage },
            totalCount,
            totalPageCount,
          },
          request: { cursor: currentCursor },
        },
      },
    },
  }
}

export function searchFailed(queryId, currentCursor, error) {
  return {
    searches: {
      queries: {
        [queryId]: {
          type: 'FAILED',
          error,
          request: { cursor: currentCursor },
        },
      },
    },
  }
}

export function searchInvalidate(queryId) {
  return {
    searches: {
      queries: {
        [queryId]: {
          type: 'INVALIDATE',
        },
      },
    },
  }
}

export function searchInvalidateEntity(entityTypes) {
  return {
    searches: {
      invalidateEntities: entityTypes,
    },
  }
}
